/**
 * Lead conversion tracking for the contact-page form (sections/muze-contact.liquid).
 *
 * The form posts natively to Shopify so reCaptcha can sign it — this only
 * observes the submit, pushes `generate_lead` to the dataLayer, and mirrors
 * the conversion server-side. It never calls preventDefault, so a failure
 * here cannot stop an enquiry reaching Muze.
 *
 * Field ids come from the section markup; the `name` attributes are built
 * from merchant-editable labels, so ids are the stable handle.
 */
import { generateEventId, sendLeadEvent, pushLeadDataLayer } from '@theme/lead-tracking';

const LEAD_SOURCE = 'contact_page';

function value(id) {
  const el = /** @type {HTMLInputElement | HTMLTextAreaElement | null} */ (
    document.getElementById(id)
  );
  return el?.value?.trim() || '';
}

function handleSubmit(form) {
  const email = value('McnContact-email');
  // No email means Shopify will reject the form anyway — don't report a
  // conversion for a submission that isn't going to land.
  if (!email) return;

  const user = {
    first_name: value('McnContact-name'),
    last_name: value('McnContact-surname'),
    email,
    phone: value('McnContact-phone'),
  };
  const eventId = generateEventId();

  pushLeadDataLayer({
    eventId,
    leadSource: LEAD_SOURCE,
    user,
    product: null,
    value: 0,
    currency: 'ZAR',
  });

  sendLeadEvent({
    event_id: eventId,
    first_name: user.first_name,
    last_name: user.last_name,
    email: user.email,
    phone: user.phone,
    country: 'za',
    product: null,
    page_url: window.location.href,
  });

  // Deliberately no preventDefault — the browser continues the native submit.
  void form;
}

function init() {
  const form = document.querySelector('form.mcn__form');
  if (!form || form.dataset.leadTracked === '1') return;
  form.dataset.leadTracked = '1';
  form.addEventListener('submit', () => handleSubmit(form));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Section re-render in the theme editor replaces the form node.
document.addEventListener('shopify:section:load', init);
